module.exports = {"340102001":"明光路街道","340102003":"胜利路街道","340102004":"三里街街道","340102005":"铜陵路街道","340102006":"七里站街道","340102007":"红光街道","340102008":"和平路街道","340102010":"城东街道","340102011":"长淮街道","340102012":"方庙街道","340102014":"嘉山路街道","340102100":"大兴镇","340102401":"合肥龙岗综合经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340102.json
// module id = 1035
// module chunks = 0